var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconeZonesARisque = function SvgIconeZonesARisque(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 5.99066L19.5301 19.0007H4.47012L12.0001 5.99066ZM2.74012 18.0007C1.97012 19.3307 2.93012 21.0007 4.47012 21.0007H19.5301C21.0701 21.0007 22.0301 19.3307 21.2601 18.0007L13.7301 4.99066C12.9601 3.66066 11.0401 3.66066 10.2701 4.99066L2.74012 18.0007ZM11.0001 11.0007V13.0007C11.0001 13.5507 11.4501 14.0007 12.0001 14.0007C12.5501 14.0007 13.0001 13.5507 13.0001 13.0007V11.0007C13.0001 10.4507 12.5501 10.0007 12.0001 10.0007C11.4501 10.0007 11.0001 10.4507 11.0001 11.0007ZM11.0001 16.0007H13.0001V18.0007H11.0001V16.0007Z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconeZonesARisque);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Icone_zones-a-risque.1192c87685a8bacfecaa2d3a360a8f44.svg";